import { set } from 'cerebral/operators'

import restorePassword from '../actions/restorePassword.js'

export default [
  restorePassword,
  {
    success: [],
    error: []
  },
  set('state:login.recovery.restore.loaded', false),
  set('state:login.recovery.restore._id', null),
  set('state:client.currentPage', 'login')
]



// WEBPACK FOOTER //
// ./src/modules/login/chains/onRestorePassword.js